import { memberGQLFields } from './member.fields.js';
import { networkGQLFields } from './network.fields.js';
import { networkPublicInfoGQLFields, } from './networkPublicInfo.fields.js';
import { roleGQLFields } from './role.fields.js';
const BASIC_AUTH_TOKEN_FIELDS = {};
const ALL_AUTH_TOKEN_FIELDS = {
    member: 'basic',
    network: 'basic',
    networkPublicInfo: 'basic',
    role: 'basic',
};
const DEFAULT_AUTH_TOKEN_FIELDS = {
    member: 'default',
    network: 'default',
    networkPublicInfo: {
        logo: 'all',
    },
    role: 'all',
};
export function authTokenGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_AUTH_TOKEN_FIELDS;
    if (fields === 'all')
        fields = ALL_AUTH_TOKEN_FIELDS;
    if (fields === 'default')
        fields = DEFAULT_AUTH_TOKEN_FIELDS;
    return `
    accessToken
    refreshToken
    ${fields.member
        ? `
      member {
        ${memberGQLFields(fields.member)}
      }
    `
        : ``}
    ${fields.network
        ? `
      network {
        ${networkGQLFields(fields.network)}
      }
    `
        : ``}
    ${fields.networkPublicInfo
        ? `
      networkPublicInfo {
        ${networkPublicInfoGQLFields(fields.networkPublicInfo)}
      }
    `
        : ``}
    ${fields.role
        ? `
      role {
        ${roleGQLFields(fields.role)}
      }
    `
        : ``}
  `;
}
